@switch (name) {
  @case ('register') {
    <ui-fh-svg-register [color]="color"></ui-fh-svg-register>
  }
  @case ('success') {
    <ui-fh-svg-success [color]="color"></ui-fh-svg-success>
  }
  @case ('completed') {
    <ui-fh-svg-completed [color]="color"></ui-fh-svg-completed>
  }
  @case ('canceled') {
    <ui-fh-svg-canceled [color]="color"></ui-fh-svg-canceled>
  }
  @case ('declined') {
    <ui-fh-svg-declined [color]="color"></ui-fh-svg-declined>
  }
  @case ('pending') {
    <ui-fh-svg-pending [color]="color"></ui-fh-svg-pending>
  }
  @case ('warning') {
    <ui-fh-svg-warning [color]="color"></ui-fh-svg-warning>
  }
  @case ('add-user') {
    <ui-fh-svg-add-user [color]="color"></ui-fh-svg-add-user>
  }
  @case ('application') {
    <ui-fh-svg-application [color]="color"></ui-fh-svg-application>
  }
  @case ('password') {
    <ui-fh-svg-password [color]="color"></ui-fh-svg-password>
  }
  @case ('waves') {
    <ui-fh-svg-waves class="d-block" [color]="color" [secondaryColor]="secondaryColor"></ui-fh-svg-waves>
  }
  @case ('approve-consult') {
    <ui-fh-svg-approve-consult class="d-block" [color]="color"></ui-fh-svg-approve-consult>
  }
  @case ('appointment') {
    <ui-fh-svg-appointment class="d-block" [color]="color"></ui-fh-svg-appointment>
  }
  @case ('authorization') {
    <ui-fh-svg-authorization class="d-block" [color]="color"></ui-fh-svg-authorization>
  }
  @case ('refunds') {
    <ui-fh-svg-refunds class="d-block" [color]="color"></ui-fh-svg-refunds>
  }
  @case ('simulator') {
    <ui-fh-svg-simulator class="d-block" [color]="color"></ui-fh-svg-simulator>
  }
  @case ('medicine') {
    <ui-fh-svg-medicine class="d-block" [color]="color"></ui-fh-svg-medicine>
  }
  @case ('agreement') {
    <ui-fh-svg-agreement class="d-block h-100" [color]="color"></ui-fh-svg-agreement>
  }
  @case ('hand-agreement') {
    <ui-fh-svg-hand-agreement class="d-block h-100" [color]="color"></ui-fh-svg-hand-agreement>
  }
  @case ('not-found') {
    <ui-fh-svg-not-found class="d-block h-100" [color]="color"></ui-fh-svg-not-found>
  }
  @case ('loading') {
    <ui-fh-svg-loading class="d-block h-100" [color]="color"></ui-fh-svg-loading>
  }
  @case ('lost-internet') {
    <ui-fh-svg-lost-internet [color]="color"></ui-fh-svg-lost-internet>
  }
  @case ('adhesion') {
    <ui-fh-svg-adhesion [color]="color"></ui-fh-svg-adhesion>
  }
  @case ('files-upload') {
    <ui-fh-svg-files-upload [color]="color"></ui-fh-svg-files-upload>
  }
}
